<script>
    import { onMount, createEventDispatcher, onDestroy, afterUpdate } from 'svelte';
    import { user, db, functions } from '../stores.js';

    const dispatch = createEventDispatcher();
    let status = "";
    let breakDetails;
    let creds;
    let session;

    let isPublishing = false;
    let audioSources = [{deviceId: null, kind: "audioInput", label: "no audio"}];
    let videoSources = [{deviceId: null, kind: "videoInput", label: "no video"}]
    let selectedAudio;
    let selectedVideo;
    let cameraContainer;
    let publisher;

    let mediaStream;

    let role = "guest";


    let mode = "preview";

    let videoElement;

    let screensharePublisher;
    let isSharing = false;

    let isConnected = false;

    let timer;

    let stopListening;
    let recognition;
    let speechStatus = "";

    let conversation;



    // Get the list of devices and populate the drop down lists
    function populateDeviceSources() {
        console.log('populateDeviceSources');
        OT.getDevices((err, devices) => {
            if (err) {
                alert('getDevices error ' + err.message);
                return;
            }
            audioSources = [...audioSources, ...devices.filter(device => device.kind === 'audioInput')]
            videoSources = [...videoSources, ...devices.filter(device => device.kind === 'videoInput')]
            return;
        });
    }

    onMount(async() => {
        // We request access to Microphones and Cameras so we can get the labels
        OT.getUserMedia().then((stream) => {
            console.log('Camera onMount! stream: ', stream);
            mediaStream = stream;
            populateDeviceSources();
            // Stop the tracks so that we stop using this camera and microphone
            // If you don't do this then cycleVideo does not work on some Android devices
            stream.getTracks().forEach(track => track.stop());
        });
        
        $db.collection("breaks").doc($user.breakId)
            .onSnapshot((doc) => {
                console.log("break session data: ", doc.data());
                breakDetails = doc.data();
                // status = "getting credentials..."
                // getCreds();
                if (timer && breakDetails.speaker_timer) {
                    console.log("timer && breakDetails.speaker_timer");
                    timer.restart(breakDetails.speaker_timer);
                }

            })
    });

    onDestroy(() => {
        console.log('onDestroy');
        if (mediaStream){
            mediaStream.getTracks().forEach(track => track.stop());
        }
        if (session) {
            session.disconnect();
        }
        if (publisher){
            publisher.destroy();

        }
    });

    afterUpdate(() => {
        console.log("afterUpdate isPublishing: ", isPublishing);
        console.log("afterUpdate isConnected: ", isConnected);
        if (isConnected && isPublishing){
            console.log("connected AND publishing!");
            console.log("afterUpdate showVideo: ", $user.showVideo);
            if(!$user.showVideo){
                stopPublishing();
            }
        }

        if (isConnected && !isPublishing){
            console.log("connected but not publishing!");
            console.log("afterUpdate showVideo: ", $user.showVideo);
            if($user.showVideo){
                startPublishing();
            }
        }


        // if (isConnected && isSharing){
        //     console.log("connected AND sharing!");
        //     console.log("afterUpdate showScreen: ", $user.showScreen);
        //     if (!$user.showScreen){
        //         stopScreensharing();
        //     }
        // }

        // if (isConnected && !isSharing){
        //     console.log("connected but not sharing!");
        //     console.log("afterUpdate showScreen: ", $user.showScreen);
        //     if ($user.showScreen){
        //         startScreensharing();
        //     }
        // }

    });


    function getCreds(){
        mode = "videoChat";
        status = "getting credentials..."

        const getCreds = $functions.httpsCallable('getCreds')
        const {conversationId, sessionId} = breakDetails;
        getCreds({userSocial:{username: $user.username, provider: $user.provider}, conversationId, sessionId})
            .then((results) => {
                // jwt, token, hacoToken, apiKey
                creds = results.data;
                console.log('creds: ', creds);
                // gotCreds = true;
                // console.log("gotCreds: ",gotCreds);
                status = "setting up video chat..."
                setUp();
                // return;

            }).catch((error)=>{
                console.log("getCreds error: ", error);
                status = `Error trying to get credentials: ${error}`;
            });
    }

    function setUp(){
        console.log("setup");
        // set up OpenTok
        session = OT.initSession(breakDetails.apiKey, breakDetails.sessionId);
        console.log('session: ', session);
        // Subscribe to a newly created stream
        session.on('streamCreated', function(event) {
            console.log("streamCreated");
            if (event.stream.videoType === 'screen'){
                console.log("streamCreated screenshare");
                session.subscribe(event.stream, 'screenshare-container', {
                insertMode: 'append',
                width: '100%',
                height: '100%',
                fitMode: 'contain'
                }, (error) => {
                    if (error){
                        console.log("streamCreated Error: ", error);
                        status = `got an error: ${error}`;
                    } else {
                        isSharing = true;
                    }
                });

            } else {
                session.subscribe(event.stream, 'subscriber', {
                insertMode: 'append',
                width: '100%',
                height: '100%'
                }, (error) => {
                    if (error){
                        console.log("streamCreated Error: ", error);
                        status = `got an error: ${error}`;
                    } else {

                    }
                });                
            }
        });

        session.on("streamDestroyed", function(event) {
            console.log("Stream " + event.stream.name + " ended. " + event.reason);
            if (event.stream.videoType === 'screen'){
                isSharing = false;
            }
        })

        // // Connect to the session
        // session.connect(creds.token, (error) => {
        //     // If the connection is successful, initialize a publisher and publish to the session
        //     if (error) {
        //         console.log("error connecting to session: ", error);
        //         status = `got an error connecting to session: ${error}`;
        //     } else {
        //         status = "connected to session";
        //         // session.publish(publisher, handleError);
        //     }
        // });
        // set up Vonage Conversation

        startPublishing();

    }

    function close(){
        publisher.destroy();

        if (session) {
            console.log("session disconnect!");
            session.disconnect();
            isConnected = false;
            status = "disconnected";
        }
        $db.collection("users").doc($user.uid).set({
            showVideo: false,
            showScreen: false
        },{ merge: true }).then(() => {
            console.log("showVideo successfully updated!");
            dispatch('close', {
                text: 'left chat.'
            });

        }).catch((error) => {
            console.error("Error updating showVideo: ", error);
        });

    }

    function showPreview(){

        mediaStream.getTracks().forEach(track => track.stop());
        videoElement.srcObject = null;
        console.log("selectedVideo: ",selectedVideo);
        console.log("selectedAudio: ",selectedAudio);
        const gumVideo = selectedVideo === null ? false : { deviceId: selectedVideo };
        const gumAudio = selectedAudio === null ? false : { deviceId: selectedAudio };
        console.log("gumVideo: ",gumVideo);
        console.log("gumAudio: ",gumAudio);

        navigator.mediaDevices.getUserMedia({
            video: gumVideo,
            audio: gumAudio
            // video: { deviceId: selectedVideo },
            // audio: { deviceId: selectedAudio }
        })
        .then(stream => {
            videoElement.srcObject = stream;
            mediaStream = stream;
        })
        .catch(err => status = err.name + ": " + err.message);
    }

    function startPublishing() {
        console.log('start Publishing');
        // setUp();
        publisher = OT.initPublisher('publisher',{
            audioSource: selectedAudio,
            videoSource: selectedVideo,
            // width: '1280px',
            // height: '720px',
            width: '100%',
            height: '100%',
            resolution: '1280x720',
            name: `${role}-camera`
        }, (err) => {
            if(err){
                alert('Publish error ' + err.message);
            } else {
                // isPublishing = true;
                // setupDeviceSwitching();
                // setupAudioLevelMeter();
            }
        });
        // Connect to session

        // session.publish(publisher);
        if (!isConnected){
            session.connect(creds.token, (error) => {
                // If the connection is successful, publish to the session
                if (error) {
                    console.error("error connecting to session: ", error);
                } else {
                    session.publish(publisher, (error) => {
                        if(error) {
                            console.error("error publishing to session: ", error);
                        } else {
                            $db.collection("users").doc($user.uid).set({
                                showVideo: true
                            },{ merge: true }).then(() => {
                                console.log("showVideo successfully updated!");
                                isConnected = true;
                                // isPublishing = true;
                                status = "connected";
                            }).catch((error) => {
                                console.error("Error updating showVideo: ", error);
                            });
                        }
                    });
                }
            });
        } else {
            if (!isPublishing) {
                console.log("already connected but not publishing! just publish!")
                session.publish(publisher, (error) => {
                    if(error) {
                        console.error("error publishing to session: ", error);
                    } else {
                        // isPublishing = true;
                    }
                });

            }

        }

        publisher.on('streamCreated', (event) => {
            console.log('publisher streamCreated! ',event);
            isPublishing = true;
            // dispatch('streamCreated', {
            //     sources: {selectedAudio, selectedVideo, name:`${role}-camera`, streamId:publisher.streamId, connection:event.stream.connection}
            // })
        });
        publisher.on('destroyed', (event) => {
            console.log('publisher stream Destroyed! ',event);
            isPublishing = false;
            // dispatch('streamDestroyed', {
            //     sources: {selectedAudio:null, selectedVideo:null, name:`${role}-camera`}
            // })
        });
        // Listen to signals in the session
        session.on("signal", function(event) {
            console.log("Signal sent from connection " + event.from.id);
            console.log("Event Data " + event.data);
            // Process the event.data property, if there is any data.
            switch (event.data) {
                case 'mutePublisher':
                    console.log('mute publisher');
                    publisher.publishAudio(false);
                    break;
                case 'unmutePublisher':
                    console.log('unmute publisher');
                    publisher.publishAudio(true);
                    break;
                default:
                    console.log(`Sorry fam, don't know what ${event.detail.sources.name} is.`);
            }

        });

    }

    function recreatePublisherEl(){
        const publisherEl = document.createElement('div');
        publisherEl.id = "publisher";
        cameraContainer.appendChild(publisherEl);
    }

    function stopPublishing(){
        console.log('stop Publishing!');
        mediaStream.getTracks().forEach(track => {console.log('track: ', track); track.stop()});
        publisher.destroy();
        // if (session) {
        //     console.log("session disconnect!");
        //     session.disconnect();
        // }
        console.log('mediaStream: ',mediaStream);
        recreatePublisherEl();
        isPublishing = false;
        // mediaStream.getTracks().forEach(track => track.stop());
        // OT.getUserMedia().then((stream) => {
        //     console.log('Camera onMount! stream: ', stream)
        //     populateDeviceSources();
        //     // Stop the tracks so that we stop using this camera and microphone
        //     // If you don't do this then cycleVideo does not work on some Android devices
        //     stream.getTracks().forEach(track => track.stop());
        // });


        // populateDeviceSources();
    }

    function startScreensharing(){
        console.log('start screen sharing');

        OT.checkScreenSharingCapability(function(response) {
            if(!response.supported || response.extensionRegistered === false) {
                // This browser does not support screen sharing.
            } else if (response.extensionInstalled === false) {
                // Prompt to install the extension.
            } else {
                // Screen sharing is available. Publish the screen.
                screensharePublisher = OT.initPublisher('screenshare-container',
                {videoSource: 'screen',
                maxResolution: { width: 1920, height: 1080},
                fitMode: 'contain',
                insertMode: "append",
                width:'100%',
                height:'100%'
                },
                function(error) {
                    if (error) {
                        // Look at error.message to see what went wrong.
                    } else {
                        session.publish(screensharePublisher, function(error) {
                            if (error) {
                            // Look error.message to see what went wrong.
                            } else {
                                $db.collection("users").doc($user.uid).set({
                                    showScreen: true
                                },{ merge: true }).then(() => {
                                    console.log("showScreen successfully updated!");
                                    // isSharing = true;
                                }).catch((error) => {
                                    console.error("Error updating showScreen: ", error);
                                });
                            }
                        });
                    }
                });
            }
        });

        screensharePublisher.on('streamCreated', (event) => {
            console.log('screen publisher streamCreated! ',event);
            isSharing = true;
            // dispatch('streamCreated', {
            //     sources: {selectedAudio, selectedVideo, name:`${role}-camera`, streamId:publisher.streamId, connection:event.stream.connection}
            // })
        });
        screensharePublisher.on('destroyed', (event) => {
            console.log('screen publisher stream Destroyed! ',event);
            isSharing = false;
            // dispatch('streamDestroyed', {
            //     sources: {selectedAudio:null, selectedVideo:null, name:`${role}-camera`}
            // })
        });

    }

    function stopScreensharing(){
        screensharePublisher.destroy();
        isSharing = false;
    }

    function disconnect(){
        if (session) {
            console.log("session disconnect!");
            session.disconnect();
            isConnected = false;
        }

    }

    async function enableSpeechRec(){
        speechStatus = "starting";
        try {
            const getJWT = $functions.httpsCallable('getJWT');
            const response = await getJWT({username: $user.username , conversationId: breakDetails.conversationId});
            const jwt = response.data.jwt;
            console.log('jwt: ',jwt);
            const client = new NexmoClient({debug:false});
            const app = await client.createSession(jwt);
            conversation = await app.getConversation(breakDetails.conversationId);
            console.log('joinRoom conversation: ',conversation);  
        }
        catch (error){
            console.error('error in setup: ', error);
            status = `Error in setup: ${error}`;
        }

        stopListening = false;
        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
        recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'en-US';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.start();

        speechStatus = "started";

        recognition.onresult = async (e) => {
            console.log('on result: ', e);
            // await conversation.sendText(`via TTS: ${e.results[0][0].transcript}`);
            await conversation.sendCustomEvent({ type: 'cctext', body: { message: e.results[0][0].transcript, displayName: $user.username } });

        }

        recognition.onspeechend = (e) => {
            console.log('on speech end: ', e);
        }

        recognition.onerror = function(event) {
            console.error('Error occurred in recognition: ' + event.error);
        }

        recognition.onaudiostart = function(event) {
            //Fired when the user agent has started to capture audio.
            console.log('SpeechRecognition.onaudiostart');
        }

        recognition.onaudioend = function(event) {
            //Fired when the user agent has finished capturing audio.
            console.log('SpeechRecognition.onaudioend');
        }


        recognition.onend = (e) => {
            console.log('on end: ', e);
            if (stopListening === false){
                recognition.start();  
            }
        }

    }

    function disableSpeechRec(){
        console.log('disableSpeechRec');
        stopListening = true;
        recognition.stop();
        speechStatus = "stopped";
    }



</script>

<button id="close-modal" on:click={close}>close</button>
<div id="container">
    {#if mode === "preview"}
        <div id="media">
            <video id="previewVideo" bind:this={videoElement} autoplay></video>
            <fieldset>
                <legend>media</legend>
                <br/><strong>Only share your video if you want to.</strong>
                <br/><strong>If you can, please have headphones.</strong>
                <br/><label for="audio-source-select">Audio Source:</label>
                <select bind:value={selectedAudio} disabled={isPublishing}>
                    {#if audioSources}
                        {#each audioSources as audioSource}
                            <option value="{audioSource.deviceId}">{audioSource.label || audioSource.kind }</option>
                        {/each}
                    {/if}
                </select>
                <br/>
                <label for="video-source-select">Video Source:</label>
                <select bind:value={selectedVideo} disabled={isPublishing}>
                    {#if videoSources}
                        {#each videoSources as videoSource}
                            <option value="{videoSource.deviceId}">{videoSource.label || videoSource.kind }</option>
                        {/each}
                    {/if}
                </select>
                <br/><button on:click={showPreview}>Preview</button>
                <button id="publish-btn" type="button" on:click={getCreds}>Publish</button>
            </fieldset>
        </div>

    {:else}
        <div id="video-container">
            <div id="screenshare-container" class:sharing={isSharing === true}></div>
            <div id="videos" bind:this={cameraContainer}>
                <div id="subscriber"></div>
                <div id="publisher"></div>
            </div>
        </div>
        <fieldset>
            <legend>timer</legend>
            <dwane-timer bind:this={timer} timer-deadline="0" countdown-start="3600000" timer-orientation="horizontal"></dwane-timer>
            <!-- {#if isPublishing}
                <button on:click={ stopPublishing }>stop</button>
            {:else}
                <button on:click={ startPublishing }>start</button>
            {/if} -->
            <!-- {#if isSharing} -->
            <button on:click={ startScreensharing }>start screenshare</button>
            <button on:click={ stopScreensharing }>stop screenshare</button>
            <br/><br/>
            <button on:click={enableSpeechRec}>enable speech rec</button><button on:click={disableSpeechRec}>disable speech rec</button>               
            <br/>{speechStatus}
            <!-- {:else} -->
            <!-- {/if} -->
        </fieldset>
    {/if}
    {status}
</div>


<style>
    button {
        cursor: pointer;
    }

    #close-modal {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
    }

    #container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        max-width: 1500px;
        margin: auto;
    }


    #video-container {
        display: flex;
        height: 100%;
        width: 100%;
    }

    #videos {
        height: 100%;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit,minmax(300px, 1fr));

    }

    #previewVideo {
        width: 100%;
    }

    #media {
        max-width: 700px;
    }

    label {
        display: inline-block;
    }

    #screenshare-container {
        width:0;
    }

    #screenshare-container.sharing {
        width: 100%;
    } 

    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        --dwane-timer-text-color: black;
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }



</style>